import { Link } from "react-router-dom";
import { ServiceIcon } from "../components/ServiceIcon";
import { EngagementMapVisual } from "../components/EngagementMapVisual";

const services = [
  {
    id: "founders",
    code: "01",
    title: "Architecture and technical strategy",
    body: "We write down how the system should fit together, what to build first, and what to leave alone.",
    output: "Written design",
  },
  {
    id: "build",
    code: "02",
    title: "Production engineering",
    body: "We ship the hard pieces ourselves: mobile and web clients, APIs, and code that talks to devices.",
    output: "Shipped systems",
  },
  {
    id: "delivery",
    code: "03",
    title: "Quality and release engineering",
    body: "Tests that fail the build when something breaks. Release steps you can run without us in the room. Hardware rigs when the product includes a device.",
    output: "Release gates",
  },
  {
    id: "align",
    code: "04",
    title: "Engineering leadership",
    body: "We sit with your team and vendors, review the work, and report status that matches what is actually shipping.",
    output: "Real status",
  },
] as const;

export function ServicesPage() {
  return (
    <section>
      <div className="page-intro page-intro--split">
        <div>
          <p className="eyebrow">Services</p>
          <h1 className="section-title">How we help</h1>
        </div>
        <p className="lead muted">
          Sometimes the gap is a hard piece of the system and you need someone
          who can design and build it. Sometimes the people are already there
          and need clearer direction. We do both.
        </p>
      </div>

      <ol className="service-rows">
        {services.map((service) => (
          <li key={service.id} className="service-row">
            <span className="service-row-code">{service.code}</span>
            <ServiceIcon id={service.id} />
            <div className="service-row-text">
              <h3>{service.title}</h3>
              <p className="muted">{service.body}</p>
            </div>
            <p className="service-row-output">
              <span>Output</span>
              {service.output}
            </p>
          </li>
        ))}
      </ol>

      <section className="home-phases" aria-labelledby="services-map-heading">
        <div className="home-section-head">
          <h2 id="services-map-heading">What you walk away with</h2>
          <p className="muted">
            Each line of work leaves something concrete behind.
          </p>
        </div>
        <EngagementMapVisual />
      </section>

      <aside className="cta-band">
        <h2>Tell us what is stuck</h2>
        <p className="muted">
          A short note about the product and the team is enough. We will say
          whether we can help and how.
        </p>
        <Link className="btn" to="/contact">
          Start a conversation
        </Link>
      </aside>
    </section>
  );
}
